import { ModalWrapper } from "app/components/modal-wrapper/modal-wrapper";
import { keyCodeTypes } from "ui/common/key-code-types";

const modalStack: ModalWrapper[] = [];

function handleGlobalKeyDown(e: KeyboardEvent) {
  if (e.key === keyCodeTypes.Esc) {
    const topModal = modalStack[modalStack.length - 1];
    if (topModal) {
      topModal.props.onClose();
    }
  }
}

export const ModalStack = {
  push(modal: ModalWrapper) {
    modalStack.push(modal);
    if (modalStack.length === 1) {
      document.addEventListener('keydown', handleGlobalKeyDown);
    }
  },

  pop(modal: ModalWrapper) {
    const index = modalStack.indexOf(modal);
    if (index !== -1) {
      modalStack.splice(index, 1);
    }
    if (modalStack.length === 0) {
      document.removeEventListener('keydown', handleGlobalKeyDown);
    }
  },

  getTop(): ModalWrapper | null {
    return modalStack.length > 0 ? modalStack[modalStack.length - 1] : null;
  }
};
